<template>
  <v-form
    ref="form"
    v-model="isFormValid"
    :disabled="loading"
    @submit.prevent="() => submitForm()"
  >
    <v-container fluid class="pa-0">
      <v-row>
        <v-col cols="12">
          <v-text-field
            v-model="formFields.email"

            label="Email"

            name="email"
            type="email"
            required

            :rules="[vRules.requiredField, vRules.typeEmail]"
          />
        </v-col>
      </v-row>

      <v-row dense justify="space-between">
        <v-col cols="12" sm="auto" order-sm="2">
          <v-btn
            block
            color="primary"
            type="submit"

            :loading="loading"
            :disabled="!isFormValid"
          >
            Enviar email
          </v-btn>
        </v-col>

        <v-col cols="12" sm="auto" order-sm="1" class="d-flex align-center">
          <v-btn
            text
            block
            color="error"

            :disabled="loading"
            to="/login"
          >
            Voltar
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </v-form>
</template>

<script>
import { requiredField, typeEmail } from '@/utils/validators';

export default {
  name: 'ForgotPasswordForm',

  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    isFormValid: false,

    formFields: {
      email: '',
    },

    vRules: {
      requiredField,
      typeEmail,
    },
  }),

  methods: {
    submitForm() {
      this.$emit('submit', { ...this.formFields });
    },
  },
};
</script>
